import { render, staticRenderFns } from "./FbComment.vue?vue&type=template&id=21599fd1&scoped=true"
import script from "./FbComment.vue?vue&type=script&lang=js"
export * from "./FbComment.vue?vue&type=script&lang=js"
import style0 from "./FbComment.vue?vue&type=style&index=0&id=21599fd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21599fd1",
  null
  
)

export default component.exports